import * as Config from '../../../config';
import React from 'react';
import ButtonIconV2 from '../common/ButtonIconV2';

import IconSettings from './svg/IconSettings';

function ButtonSettings() {
  const onClick = () => {
    window.open(`https://www.${Config.APP_NAME}.com/account/carts`, `_blank`);
  }
  return <ButtonIconV2
    icon={<IconSettings />}
    label={`Cart Settings`}
    onClick={onClick}
  />
}

export default ButtonSettings;
